// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RoleNewQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type RoleNewQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: { __typename?: "Organization"; name: string } | null;
};

export const RoleNewDocument = gql`
  query RoleNew($organizationSlug: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      name
    }
  }
`;

/**
 * __useRoleNewQuery__
 *
 * To run a query within a React component, call `useRoleNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleNewQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useRoleNewQuery(
  baseOptions: Apollo.QueryHookOptions<RoleNewQuery, RoleNewQueryVariables> &
    ({ variables: RoleNewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RoleNewQuery, RoleNewQueryVariables>(
    RoleNewDocument,
    options,
  );
}
export function useRoleNewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoleNewQuery,
    RoleNewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RoleNewQuery, RoleNewQueryVariables>(
    RoleNewDocument,
    options,
  );
}
// @ts-ignore
export function useRoleNewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoleNewQuery,
    RoleNewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RoleNewQuery, RoleNewQueryVariables>;
export function useRoleNewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleNewQuery, RoleNewQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RoleNewQuery | undefined,
  RoleNewQueryVariables
>;
export function useRoleNewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleNewQuery, RoleNewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RoleNewQuery, RoleNewQueryVariables>(
    RoleNewDocument,
    options,
  );
}
export type RoleNewQueryHookResult = ReturnType<typeof useRoleNewQuery>;
export type RoleNewLazyQueryHookResult = ReturnType<typeof useRoleNewLazyQuery>;
export type RoleNewSuspenseQueryHookResult = ReturnType<
  typeof useRoleNewSuspenseQuery
>;
export type RoleNewQueryResult = Apollo.QueryResult<
  RoleNewQuery,
  RoleNewQueryVariables
>;
